import { Navigate } from 'react-router-dom';
import { useOrganisation } from '../contexts/OrganisationContext';

const ProtectedAdminRoute = ({ children }) => {
    const { activeRoleId } = useOrganisation();

    if (activeRoleId !== 'inera-administrator') {
        return <Navigate to="/start" replace />;
    }

    return children;
};

export default ProtectedAdminRoute;